import React from 'react';
import { crawlerDuplicateAvoidStyle } from '../../utils/commonUtils';
type InfosProps = {
  infos: {
    query: string;
    info: string;
  }[];
};

const InfoCard = ({ infos }: InfosProps) => {
  return (
    <>
      <div className="infoCard">
        <h2 style={crawlerDuplicateAvoidStyle} className="mobileShow appendBottom15 font22 infoCardHeading latoLight">
          {`Information regarding Covid19 Special Trains`}
        </h2>
        {infos.map(({ query, info }, idx) => (
          <div key={'info_' + idx} className="info">
            <div className="infoCardSubHeading latoBold blackText appendBottom5">{query}</div>
            <div className="infoCardInfo darkGreyText">{info}</div>
          </div>
        ))}
        <div className="latoBlack">{`Have further queries? Read our FAQs to know more.`}</div>
      </div>
    </>
  );
};
export default InfoCard;
